import React from "react";
import "./Spinner.scss";

const LoadingSpinner = () => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner-border" role="status">
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
